/**
* 系统管理 用户管理
*/
<template>
  <div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="用户名">
        <el-input
          size="small"
          v-model="formInline.ConsumerUserNickName"
          placeholder="输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          size="small"
          v-model="formInline.ConsumerUserTel"
          placeholder="输入手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户类别">
        <el-select
          v-model="formInline.UserType"
          @change="resetData"
          placeholder="请选择用户类别"
        >
          <el-option label="全部" value="全部"></el-option>
          <el-option label="普通用户" value="普通用户"></el-option>
          <el-option label="管理员" value="管理员"></el-option>
          <el-option label="店主" value="店主"></el-option>
          <el-option label="已禁言" value="已禁言"></el-option>
          <el-option label="已拉黑" value="已拉黑"></el-option>
          <el-option label="VIP" value="VIP"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="userData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      height="70vh"
      style="width: 100%;margin-bottom:40px"
    >
      <el-table-column
        align="center"
        prop="IDX"
        label="序号"
        width="120"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="ConsumerUserNickName"
        label="用户名称"
        width="120"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="ConsumerUserTel"
        label="手机号"
        width="120"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="UserType"
        label="角色/状态"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="CREATETIME"
        label="创建时间"
        min-width="120"
      >
      </el-table-column>
      <el-table-column label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            class="no"
            @click="handleEdit(scope.$index, scope.row)"
            >用户管理</el-button
          >
          <el-button
            type="text"
            size="mini"
            class="no"
            @click="sendMsg(scope.$index, scope.row)"
            >发消息</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <mPage
      :page="pageparm.page"
      :total="pageparm.total"
      @change="changePage"
    ></mPage>

    <!-- 编辑界面 -->
    <el-dialog
      title="用户管理"
      :rules="rules"
      :visible.sync="editFormVisible"
      width="30%"
      @close="closeDialog('edit')"
    >
      <el-form label-width="120px" ref="managerForm" :model="managerForm">
        <el-form-item label="禁言该用户">
          <el-radio-group
            v-model="managerForm.estoppel"
            @change="changeestoppel"
          >
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="设为VIP">
          <el-radio-group v-model="managerForm.isVip" @change="changeisVip">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="拉黑该用户">
          <el-radio-group
            v-model="managerForm.blacklist"
            @change="changeblacklist"
          >
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="设为管理员" prop="administrator">
          <el-radio-group
            v-model="managerForm.eadministrator"
            @change="changeeadministrator"
          >
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label-width="0" v-if="managerForm.eadministrator == '是'">
          <div class="flex">
            <el-input
              v-model="mobile"
              placeholder="请输入管理员电话号码"
              class="marginRight"
            ></el-input>
            <el-button size="small" type="primary" @click="submit"
              >确定</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false"
          >取消</el-button
        >
        <!-- <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm()"
          >保存</el-button
        > -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mPage from "../../components/mPage.vue";
import base64 from "../../utils/base64";
let flag = true;
export default {
  components: { mPage },
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: "添加用户",
      editFormVisible: false, //控制编辑页面显示与隐藏

      formInline: {
        ConsumerUserNickName: "",
        ConsumerUserTel: "",
        UserType:'全部'
      },
      // 编辑与添加
      editForm: {
        userId: "",
        userName: "",
        createTime: "",
        userRole: "",
        userMobile: "",
        UserType:''
      },
      mobile: "",
      managerForm: {
        estoppel: "否",
        isVip: "否",
        blacklist: "否",
        eadministrator: "否",
      },
      //用户数据
      userData: [],
      selectedUserInfo: {},
      user: {},
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },

      // rules表单验证
      rules: {
        estoppel: [
          {
            required: true,
            message: "请选择是否禁言该用户",
            trigger: "change",
          },
        ],
        isVip: [
          { required: true, message: "请选择是否设为VIP", trigger: "change" },
        ],
        blacklist: [
          {
            required: true,
            message: "请选择是否拉黑该用户",
            trigger: "change",
          },
        ],
        eadministrator: [
          {
            required: true,
            message: "请选择是否设为管理员",
            trigger: "change",
          },
        ],
      },
    };
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.user = JSON.parse(this.$util.getStore("personInfo"));
    this.getdata();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    resetData() {
      this.userData = [];
      this.pageparm = {
        page: 1,
        limit: 10,
        total: 10,
      };
    },
    // 获取数据方法
    getdata() {
      let { user, formInline } = this;

      let data = {
        UserTel: formInline.ConsumerUserTel,
        ShopGUID: "",
        CompanyGUID: user.CompanyGUID,
        ConsumerUserNickName:
          formInline.ConsumerUserNickName != ""
            ? encodeURIComponent(formInline.ConsumerUserNickName)
            : "",
        PageNumber: this.pageparm.page-1,
        UserType: formInline.UserType,
      };
      this.loading = true;
      this.$api
        .QueryDataFn("Web\\GetAllConsumerUserList_1_0_1&DBC=w_m", data)
        .then((res) => {
          this.loading = false;
          console.log(res, 21555);
          if (res.data.OK != "True") {
            this.$message.error(result.data.Message);
          } else if (res.data.Tag.length <= 0) {
            this.canNext =false
          } else {
            let userInfo = res.data.Tag[0].Table;
            for (let i in userInfo) {
              userInfo[i].ConsumerUserNickName = decodeURIComponent(
                userInfo[i].ConsumerUserNickName
              ).trim();
            }
            this.userData = userInfo;
            this.canNext = userInfo.length > 0 ? true : false;
          }
        });
    },
    changePage(e, i) {
      let {total,page}=this.pageparm;
        if (e == 1) {
            page--;
            this.canNext = page < 1 ? false : true;
        } else {
            if (this.canNext) {
                page++;
            } else {
              total = page;
            }
        }
        this.pageparm.page = page;
        this.pageparm.total = total;
        if (this.canNext) {
            this.getdata();
        }
    },
    // 分页插件事件
    callFather(parm) {},
    //显示编辑界面
    handleEdit: function (currentIndex, selectedUserInfo) {
      this.editFormVisible = true;
      console.log(currentIndex, selectedUserInfo, 111109);
      let estoppel = "否",
        isVip = "否",
        blacklist = "否",
        eadministrator = "否";
      if (selectedUserInfo.UserType == "管理员") {
        eadministrator = "是";
        // } else if (selectedUserInfo.UserType == "店主") {
        //   shopkeeperSwitch = true;
      } else if (selectedUserInfo.UserType == "已禁言") {
        estoppel = "是";
      } else if (selectedUserInfo.UserType == "已拉黑") {
        blacklist = "是";
      } else if (selectedUserInfo.UserType == "VIP") {
        isVip = "是";
      }
      this.managerForm = {
        estoppel,
        isVip,
        blacklist,
        eadministrator,
      };
      this.selectedUserInfo = selectedUserInfo;
    },
    sendMsg(i, row) {
      this.$prompt("内容", "发消息", {
        confirmButtonText: "确定发送",
        showCancelButton: false,
        inputType: "textarea",
        inputPattern: /^.+$/,
        customClass: "mflex",
        inputErrorMessage: "请输入要发送的内容",
      })
        .then(({ value }) => {
          this.loading = true;
          let Body = {
            type: "text",
            value: value,
          };
          Body = base64.encode(JSON.stringify(Body));
          this.$api
            .PluginFn("Plugin_df_im.Send", {
              ChatType: 1,
              From: this.user.ShopGUID,
              FromPhoto: this.user.ShopLOGO,
              FromNick: this.user.ShopName,
              To: row.ConsumerUserGUID,
              Body,
              Platform: "b", //枚举:b,c
            })
            .then((res) => {
              console.log(res, 2222);
              let result = res.data;
              if (result.OK != "True") {
                this.$message.error(result.Message);
              } else if (result.Tag[0] == 0) {
                this.$message("发送失败");
              } else {
                this.$message.success("发送成功");
              }
              this.loading = false;
            });
        })
        .catch(() => {
          console.log(39888);
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    changeestoppel(e) {
      let { isVip, blacklist, eadministrator } = this.managerForm;
      if (blacklist == "是") {
        this.$message.error("请先解除拉黑");
        this.managerForm.estoppel = "否";
        return;
      }
      if (eadministrator == "是") {
        this.managerForm.estoppel = "否";
        this.$message.error("请先取消管理员身份");
        return;
      }

      //禁言
      if (e == "否") {
        //已禁言  去解除禁言
        this.editState(
          "ShopWebApp\\RelieveConsumerUserBlacklistOrForbiddenWords_1_0_1",
          "禁言",
          "解除"
        );
      } else {
        //去禁言
        this.editState(
          "ShopWebApp\\PutConsumerUserOnForbiddenWords_1_0_1",
          "禁言",
          "设置"
        );
      }
    },
    changeisVip(e) {
      if (e == "否") {
        //已设为VIP  去解除VIP
        this.editState(
          "ShopWebApp\\RelieveConsumerUserBlacklistOrForbiddenWords_1_0_1",
          "VIP",
          "解除"
        );
      } else {
        //去禁言
        this.editState(
          "ShopWebApp\\PutConsumerUserOnVipUser_1_0_1",
          "VIP",
          "设置"
        );
      }
    },
    changeblacklist(e) {
      if (e == "否") {
        //已拉黑  去解除拉黑
        this.editState(
          "ShopWebApp\\RelieveConsumerUserBlacklistOrForbiddenWords_1_0_1",
          "拉黑",
          "解除"
        );
      } else {
        //去拉黑
        this.editState(
          "ShopWebApp\\PutConsumerUserOnBlacklist_1_0_1",
          "拉黑",
          "设置"
        );
      }
    },
    changeeadministrator(e) {
      let { estoppel, blacklist } = this.managerForm;
      if (e == "否") {
        //已设为管理员  去解除管理员
        that.editState(
          "ShopWebApp\\DisqualificationBusinessUser_1_0_1",
          "管理员",
          "解除"
        );
      } else {
        if (estoppel == "是") {
          this.$message.error("请先解除禁言");
          this.managerForm.eadministrator = "否";
          return;
        }
        if (blacklist == "是") {
          this.$message.error("请先解除拉黑");
          this.managerForm.eadministrator = "否";
          return;
        }
        //去设为管理员
        this.selectedUserInfo.EditState = "管理员";
      }
    },

    //设置为管理员
    submit() {
      let mobile = this.mobile;
      if (flag) {
        flag = false;
        if (mobile.trim() == "") {
          flag = true;
          this.$message.error("手机号码不能为空");
          return;
        }
        if (
          !/^1(1|2|3|4|5|6|7|8|9)\d{9}$/.test(mobile) ||
          mobile.length != 11
        ) {
          flag = true;
          this.$message.error("手机号码格式不正确");
          return;
        }
        let personInfo = this.user;
        let selectedUserInfo = this.selectedUserInfo;
        let transactionName = "";
        let data = [];
        let parameter1 = [
          {
            ConsumerUserGUID: selectedUserInfo.ConsumerUserGUID,
          },
        ];
        let parameter2 = [
          {
            ConsumerUserGUID: selectedUserInfo.ConsumerUserGUID,
            ConsumerUserTel: mobile,
            BusinessUserGUID: personInfo.UserGUID,
          },
        ];
        if (selectedUserInfo.EditState == "管理员") {
          if (
            parseFloat(personInfo.UserType) == 1 ||
            parseFloat(personInfo.UserType) == 2
          ) {
            transactionName = "将用户设置为业主管理员";
            data = [
              {
                SqlCmdName:
                  "ShopWebApp\\PutConsumerUserOnCompanyController_1_0_1",
                DBC: "w_m",
                Parameter: JSON.stringify(parameter1),
              },
              {
                SqlCmdName:
                  "ShopWebApp\\InsertBusinessUserCompanyControllerInfo_1_0_1",
                DBC: "w_m",
                Parameter: JSON.stringify(parameter2),
              },
            ];
          } else if (
            parseFloat(personInfo.UserType) == 3 ||
            parseFloat(personInfo.UserType) == 4
          ) {
            transactionName = "将用户设置为商铺管理员";
            data = [
              {
                SqlCmdName: "ShopWebApp\\PutConsumerUserOnShopController_1_0_1",
                DBC: "w_m",
                Parameter: JSON.stringify(parameter1),
              },
              {
                SqlCmdName:
                  "ShopWebApp\\InsertBusinessUserShopControllerInfo_1_0_1",
                DBC: "w_m",
                Parameter: JSON.stringify(parameter2),
              },
            ];
          }
          this.submitData(transactionName, data);
        } else {
          transactionName = "将用户设置为店主";
          this.$api.returnGuid(
            (guid) => {
              parameter2[0].ShopGUID = guid;
              data = [
                {
                  SqlCmdName: "ShopWebApp\\PutConsumerUserOnShopMaster_1_0_1",
                  DBC: "w_m",
                  Parameter: JSON.stringify(parameter1),
                },
                {
                  SqlCmdName:
                    "ShopWebApp\\InsertBusinessUserShopMasterInfo_1_0_1",
                  DBC: "w_m",
                  Parameter: JSON.stringify(parameter2),
                },
                {
                  SqlCmdName: "ShopWebApp\\InsertShopInfo_1_0_1",
                  DBC: "w_m",
                  Parameter: JSON.stringify(parameter2),
                },
              ];
              this.submitData(transactionName, data);
            },
            (err) => {
              flag = true;
            }
          );
        }
      }
    },

    submitData(transactionName, data) {
      this.loading = true;
      this.$api
        .exsqlDistributedUrl(transactionName, JSON.stringify(data))
        .then((result) => {
          if (result.OK != "True") {
            this.$message(result.Message);
          } else {
            this.editFormVisible = false;
            this.getdata();
          }
          this.loading = false;
        });
    },
    editState(sqlCmdName, type, state) {
      //type 禁言、拉黑、店主、管理员  state 设置、解除
      let that = this;
      let selectedUserInfo = that.selectedUserInfo;
      let data = [
        {
          ConsumerUserGUID: selectedUserInfo.ConsumerUserGUID,
        },
      ];
      this.loading = true;
      this.$api
        .ExSqlFn(sqlCmdName + "&DBC=w_m", JSON.stringify(data))
        .then((res) => {
          let result = res.data;
          console.log(result, 569);
          if (result.OK != "True") {
            this.loading = false;
            this.$message.error(result.Message);
          } else if (result.Tag[0] == 0) {
            this.loading = false;
            flag = true;
            this.$message(state + type + "失败");
          } else {
            this.getdata();
            let str = state + type + "成功";
            console.log(str, 626);
            this.$message(str);
          }
          this.editFormVisible = false;
        });
    },
    handleClick(data, checked, node) {},
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {},
    // 选中菜单
    changemenu(arr) {
      let change = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].checked) {
          change.push(arr[i].id);
        }
      }
      return change;
    },
    search() {
      this.userData = [];
      this.pageparm.page = 1;
      this.getdata();
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/user.vue